import { render } from "./SpreadSheet.vue?vue&type=template&id=33488939&ts=true"
import script from "./SpreadSheet.vue?vue&type=script&lang=ts"
export * from "./SpreadSheet.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/user/Desktop/kafka/paletteiot/pletteiotweb/PaletteIoTDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__